import { createSlice } from "@reduxjs/toolkit";
import urlStorage from "src/support/urlStorage";
import {
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY,
  isAdminUserLastLoginDateSearchEnabled,
  sanitizeAdminAccountFilterList
} from "src/support/AdminLastLoginDateSearch";

const getInitialFilterList = () => {
  const urlList = urlStorage.getItem('ac');
  const sanitizedUrlList = sanitizeAdminAccountFilterList(urlList);
  const hasStoredLastLoginDateFilter = Boolean(urlList?.[ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY]);

  if (!isAdminUserLastLoginDateSearchEnabled() && hasStoredLastLoginDateFilter) {
    if (Object.entries(sanitizedUrlList).length > 0) {
      urlStorage.setItem('ac', sanitizedUrlList);
    } else {
      urlStorage.removeItem('ac');
    }
  }

  return sanitizedUrlList;
};

const slice = createSlice({
  name: "AdminAccountFilter",
  initialState: {
    filterList: getInitialFilterList()
  },
  reducers: {
    setFilterList: {
      reducer: (state, action) => {
        state.filterList = sanitizeAdminAccountFilterList(action.payload);
        urlStorage.setItem('ac', state.filterList);
      }
    },
    clearFilterByKey: {
      reducer: (state, action) => {
        const keyToDelete = action.payload;

        delete state.filterList[keyToDelete];
        if (Object.entries(state.filterList).length > 0) {
          urlStorage.setItem('ac', state.filterList);
        } else {
          urlStorage.removeItem('ac');
        }
        return state;
      }
    },
    clearAllFilter: {
      reducer: (state, action) => {
        state.filterList = {};
        urlStorage.removeItem('ac');
        return state;
      }
    },
    clearArryVal: {
        reducer: (state, action) => {
            function deleteFilterItem(filterList, filterKey, value) {
                if (filterList[filterKey] && filterList[filterKey].searchKeywordArr.length === 1) {
                    delete filterList[filterKey];
                } else if (filterList[filterKey]) {
                    filterList[filterKey].searchKeywordArr = filterList[filterKey].searchKeywordArr.filter(item => item.value !== value);
                }
            }
            const { key, value } = action.payload.data;

            if (key) {
                deleteFilterItem(state.filterList, key, value);
            }
    
            urlStorage.setItem('ac', state.filterList);
            return state;
        }
      }
  }
});

export const { setFilterList, clearFilterByKey, clearAllFilter, clearArryVal } = slice.actions;

export default slice.reducer;
